module.exports = __webpack_public_path__ + "static/img/yeying.0a83cf9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/yeying.png
// module id = F/se
// module chunks = 0